import classNames from "classnames";
import { RichText } from "components/RichTextWidget";
import {
  Container,
  Heading3,
  Icon,
  PageLink,
  Paragraph,
} from "shared/components";

import styles from "./Content046.module.scss";

export const Content046 = ({ payload }) => {
  const title = payload?.title ?? "";
  const description = payload?.description ?? "";
  const appearance = payload?.template ?? "light";
  const buttonText = payload?.button?.buttonText ?? "";
  const link = payload?.button?.link ?? "";
  const target = payload?.button?.target ?? "_blank";

  return (
    <div
      className={classNames({
        [styles.background]: appearance === "light",
      })}
    >
      <Container>
        <div className={classNames(styles.block, styles[appearance])}>
          <PageLink link={link} className={styles.link} target={target}>
            <span className={styles.arrow}>
              <Icon className={styles.icon} name="large_arrow_right" />
            </span>
            <Paragraph
              color={appearance === "light" ? "brand" : "light"}
              appearance="bigger"
              className={styles["button-text"]}
            >
              {buttonText}
            </Paragraph>
          </PageLink>

          <div className={styles.text}>
            <Heading3 className={styles.title} color="dark">
              {title}
            </Heading3>
            <RichText value={description} className={styles.description} />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Content046;
